import { inject, Injectable } from '@angular/core';
import { UseCase } from '@shared/helper';
import { PostCartDto, PostCartResp } from './cart.interface';
import { Observable } from 'rxjs';
import { CheckoutRepository } from '@data/repositories/checkout.repository';

@Injectable({
    providedIn: 'root'
})

export class PostCartUsecase implements UseCase<PostCartDto, PostCartResp> {
    checkoutRepository = inject(CheckoutRepository);

    execute(params: PostCartDto): Observable<PostCartResp> {
        return this.checkoutRepository.PostCart(params);
    }
}